import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row mb-5 pb-5 justify-content-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row p-0" }
const _hoisted_6 = { class: "col-12 p-0" }
const _hoisted_7 = { class: "card p-3 mb-4 bg-yellow-gradient border-radius-10 d-block" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Account Type")
  ]),
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-12 mt-2" }, " Fund Management ")
], -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Balance")
], -1)
const _hoisted_12 = { class: "font-white font-size-12 mt-2" }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Name")
], -1)
const _hoisted_16 = { class: "font-white font-size-12 mt-2" }
const _hoisted_17 = {
  class: "col-6",
  style: {"overflow-y":"auto","max-height":"125px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-6 ac-last-first-c" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Reference")
], -1)
const _hoisted_22 = { class: "font-white font-size-12 mt-2" }
const _hoisted_23 = { class: "col-6 ac-last-first-c" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Date Account Established ")
], -1)
const _hoisted_25 = { class: "font-white font-size-12 mt-2" }
const _hoisted_26 = { class: "col-12 p-0" }
const _hoisted_27 = { class: "card p-0 bg-white border-radius-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 d-block text-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Portfolio")
    ])
  ])
], -1)
const _hoisted_29 = { class: "row my-3 justify-content-center" }
const _hoisted_30 = { class: "col-md-12 px-4 py-2" }
const _hoisted_31 = { class: "card p-2 bg-card-grey border-radius-10" }
const _hoisted_32 = { class: "row mt-3 mx-1" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "form-control bg-white d-flex justify-content-between p-3" }
const _hoisted_35 = { class: "width-110 font-grey font-size-12" }
const _hoisted_36 = { class: "font-grey font-size-12" }
const _hoisted_37 = { class: "font-grey font-size-12" }
const _hoisted_38 = { class: "col-md-12 p-0" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = {
  class: "form-control d-flex justify-content-between p-3",
  style: {"background":"#6F7F9B!important"}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("b", { class: "width-110 font-white font-size-12" }, "Total", -1)
const _hoisted_42 = { class: "font-white font-size-12" }
const _hoisted_43 = { class: "col-md-8" }
const _hoisted_44 = { class: "p-0 bg-white border-radius-10" }
const _hoisted_45 = {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_46 = { class: "col-md-8 d-flex py-4 justify-content-start" }
const _hoisted_47 = { class: "font-size-16 font-grey m-0" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", { style: {"color":"#ff7d00","margin":"10px","cursor":"pointer"} }, "Fees", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", {
  class: "font-size-12 font-gray2",
  id: "transSubTitle"
}, null, -1)
const _hoisted_50 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_51 = ["selected", "data-id", "value"]
const _hoisted_52 = { class: "row px-3" }
const _hoisted_53 = { class: "col-md-12 table-responsive" }
const _hoisted_54 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Month"),
    /*#__PURE__*/_createElementVNode("th", null, "Highest Balance"),
    /*#__PURE__*/_createElementVNode("th", null, "Fee"),
    /*#__PURE__*/_createElementVNode("th", null, "GST"),
    /*#__PURE__*/_createElementVNode("th", null, "Fee Amount (Inc. GST)"),
    /*#__PURE__*/_createElementVNode("th", null, "Paid Aamount")
  ])
], -1)
const _hoisted_56 = { id: "cashac_fee_list" }
const _hoisted_57 = ["data-feeId", "id"]
const _hoisted_58 = {
  key: 0,
  class: "fundac_fees"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", { colspan: "6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No records found")
], -1)
const _hoisted_60 = [
  _hoisted_59
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.default_currency) + " " + _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.fund.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.fund.userac_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                        return (_openBlock(), _createElementBlock("h5", {
                          class: "font-white font-size-12 mt-2",
                          key: subac.subac_id
                        }, [
                          _createTextVNode(_toDisplayString(subac.subac_name), 1),
                          _hoisted_18,
                          _createTextVNode(" " + _toDisplayString(subac.currency_name) + " " + _toDisplayString(subac.currency_symbol) + _toDisplayString(subac.subac_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("h5", _hoisted_22, " #" + _toDisplayString(_ctx.fund.userac_reference_code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.fund.userac_establish_date), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-md-12 p-0",
                              key: ac.userac_id
                            }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("b", _hoisted_35, _toDisplayString(ac.ac_name), 1),
                                  _createElementVNode("p", _hoisted_36, _toDisplayString(ac.ac_percent.toFixed()) + " % ", 1),
                                  _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.total_active_default_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("h5", _hoisted_47, [
                    _createElementVNode("b", {
                      style: {"cursor":"pointer"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {this.$router.push('/my-account/fum');})
                    }, "Transactions"),
                    _createTextVNode("   | "),
                    _hoisted_48,
                    _hoisted_49
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("select", {
                    class: "text-right w-100 trans-filter",
                    id: "selected_subac_id",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterTrans($event)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                      return (_openBlock(), _createElementBlock("option", {
                        selected: subac.subac_id == _ctx.active_subac,
                        key: subac.subac_id,
                        "data-id": 'subTitle'+subac.subac_id,
                        value: subac.subac_id
                      }, _toDisplayString(subac.subac_name) + " (" + _toDisplayString(subac.currency_name) + ") ", 9, _hoisted_51))
                    }), 128))
                  ], 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("table", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("tbody", _hoisted_56, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fundac_fees, (fee) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: fee.fee_id,
                          "data-feeId": fee.fee_id,
                          id: 'fee_'+fee.fee_id,
                          class: "fundac_fees"
                        }, [
                          _createElementVNode("td", null, _toDisplayString(fee.f_time), 1),
                          _createElementVNode("td", null, _toDisplayString(fee.fee_highest_fund_ac_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1),
                          _createElementVNode("td", null, _toDisplayString(fee.fee_percent) + " % ", 1),
                          _createElementVNode("td", null, _toDisplayString(fee.fee_gst) + " % ", 1),
                          _createElementVNode("td", null, _toDisplayString(fee.fee_inc_gst_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1),
                          _createElementVNode("td", null, _toDisplayString(fee.fee_paid_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ], 8, _hoisted_57))
                      }), 128)),
                      (!_ctx.fundac_fees.length)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_58, _hoisted_60))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}